// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetClustersForMapRequest, TGetClustersForMapModel, IMappers, TGetClustersForMapResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetClustersForMapResponseSchema } from '../../entities/get_clusters_for_map_web/V1GetClustersForMapResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetClustersForMapModel(parameters: TGetClustersForMapRequest): TGetClustersForMapModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-offers-index',
    pathApi: '/v1/get-clusters-for-map/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetClustersForMapOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetClustersForMapRequest;
}

export async function fetchGetClustersForMap<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetClustersForMapOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetClustersForMapResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetClustersForMapModel(parameters),
    config,
  )) as FetchResponse<TGetClustersForMapResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetClustersForMapResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetClustersForMapResponse>;
}
